import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "tracker-textarea",
  relative: ""
}
const _hoisted_2 = {
  key: 0,
  class: "title"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.title), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_TextArea, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
      maxlength: 1024,
      placeholder: $props.placeholder
    }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
    _createVNode(_component_Icon, {
      icon: "resize-handle",
      class: "resize-handle",
      stroke: "var(--brand-100)",
      size: "1.2rem"
    })
  ]))
}